import React from 'react';

// This is the table constant/Settings which needed to render table elements
export const unitUsahaTable = (handleEdit, handleDelete) => {
  return [
      {
          title: "Id Unit Usaha",
          render: rowData => {
              return <span>{rowData.id_unit_usaha}</span>
          }
      },
      {
          title: "Bidang Usaha",
          render: rowData => {
              return <span>{rowData.bidang_usaha}</span>
          }
      },
      {
          title: "Penanggung Jawab",
          render: rowData => {
              return <span>{rowData.penanggung_jawab}</span>
          }
      },
      {
          title: "Kode Unit Usaha",
          render: rowData => {
              return <span>{rowData.kode_unit_usaha}</span>
          }
      },
      {
          title: "Unit Usaha",
          render: rowData => {
              return <span>{rowData.unit_usaha}</span>
          }
      },
      {
          title: "Created At",
          render: rowData => {
              return <span>{rowData.created_at}</span>
          }
      },
      {
        title: "Updated At",
        render: rowData => {
            return <span>{rowData.updated_at}</span>
        }
    },
      {
          title: "Action",
          render: rowData => {
              return (
                  <>
                    <button className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2" onClick={(e) => handleEdit(rowData)}>Edit</button>
                    <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" onClick={(e) => handleDelete(rowData)}>Delete</button>
                  </>
              )
          }
      }
  ];
};
